import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';

import axios from './axios';

export interface UseDeleteRecordingsVariables {
  recordings: Array<number>;
}

export interface UseDeleteRecordingsData {}

export function useDeleteRecordings() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseDeleteRecordingsData,
    AxiosError<UseDeleteRecordingsData>,
    UseDeleteRecordingsVariables
  >(
    (variables) => {
      const config = { data: variables };

      return axios
        .delete<UseDeleteRecordingsData>('/posht/yashar/recordings/', config)
        .then((res) => res.data);
    },
    {
      onError: (error, variables, context) => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },

      onSettled: () => {
        queryClient.invalidateQueries('recordings');
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
